<div class="layout-centered">
  <p-card styleClass="card-style-account">
    <ng-template pTemplate="header">
      <img src="/assets/images/logo-redcurve.png" id="logo-redcurve" />
    </ng-template>

    <h1 class="h3">Two-Factor Authentication</h1>
    <p>Send my verification code to:</p>

    <div *ngIf="errorMessage" class="error">
      <p-message severity="error" [text]="errorMessage"></p-message>
    </div>

    <div class="mb-5" [formGroup]="twoFactorForm">
      <div *ngFor="let option of options">
          <div class="flex flex-column gap-3">
            <div class="flex align-items-center">
              <p-radioButton [inputId]="option.type"
                  [value]="option"
                  formControlName="selectedOption"></p-radioButton>
              <label [for]="option.value" class="ml-2">
                <strong>{{ option.type }}:</strong> {{ option.value }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-3">
        <button pButton label="Send" (click)="sendCode()" [disabled]="twoFactorForm.invalid"></button>
      </div>
  </p-card>

  <div class="centered-footer">
    <span>Copyright &copy; 2025</span> |
    <span>RedCurve Solutions &reg;</span> |
    <span>All Rights Reserved</span>
  </div>
</div>
